import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useList() {
  // Use toast
  const toast = useToast()

  const refUserListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'datePost', label: 'Tanggal', sortable: true },
    // { key: 'tiket_pengajuan.hak_akses', label: 'User Pengajuan', sortable: true },
    { key: 'tiket_pengajuan.nama_upt', label: 'UPT', sortable: true },
    { key: 'tiket_pengajuan.nama_kanwil', label: 'KANWIL', sortable: true },
    { key: 'created_by_user.name', label: 'User', sortable: true },
    { key: 'select_kategori_jenis_tiket.nama', label: 'Kategori Konsultasi', sortable: true },
    { key: 'select_jenis_tiket.nama', label: 'Jenis Konsultasi', sortable: true },
    // { key: 'permasalahan', label: 'Permasalahan', sortable: true },
    { key: 'status_tiket.nama', label: 'Status', sortable: true },
    // { key: 'tanggal_mulai', label: 'Tanggal Mulai', sortable: true },
    { key: 'actions' },
  ]
  const perPage = ref(10)
  const totalUsers = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const kanwilFilter = ref(null)
  const uptFilter = ref(null)
  const kategoriFilter = ref(null)
  const statusFilter = ref(null)
  const jenisFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value ? refUserListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalUsers.value,
    }
  })

  const refetchData = () => {
    refUserListTable.value.refresh()
  }

  watch(
    [
      currentPage,
      perPage,
      searchQuery,
      kanwilFilter,
      uptFilter,
      kategoriFilter,
      statusFilter,
      jenisFilter,
    ],
    () => {
      refetchData()
    },
  )

  const fetchDatas = (ctx, callback) => {
    store
      .dispatch('keterampilan/fetchDatas', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        kanwil_filter: kanwilFilter.value,
        jenis_filter: jenisFilter.value,
        upt_filter: uptFilter.value,
        kategori_filter: kategoriFilter.value,
        status_filter: statusFilter.value,
        defaultColDef: {
          resizable: true,
        },
      })
      .then(response => {
        const { data, total } = response.data
        callback(data)
        totalUsers.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Tidak dapat mengambil data',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserRoleVariant = role => {
    if (role === 'subscriber') return 'primary'
    if (role === 'author') return 'warning'
    if (role === 'maintainer') return 'success'
    if (role === 'editor') return 'info'
    if (role === 'admin') return 'danger'
    return 'primary'
  }

  const resolveUserRoleIcon = role => {
    if (role === 'subscriber') return 'UserIcon'
    if (role === 'author') return 'SettingsIcon'
    if (role === 'maintainer') return 'DatabaseIcon'
    if (role === 'editor') return 'Edit2Icon'
    if (role === 'admin') return 'ServerIcon'
    return 'UserIcon'
  }

  const resolveUserStatusVariant = status => {
    if (status === 'pending') return 'warning'
    if (status === 'active') return 'success'
    if (status === 'inactive') return 'secondary'
    return 'primary'
  }

  return {
    fetchDatas,
    tableColumns,
    perPage,
    currentPage,
    totalUsers,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUserListTable,

    resolveUserRoleVariant,
    resolveUserRoleIcon,
    resolveUserStatusVariant,
    refetchData,

    // Extra Filters
    kanwilFilter,
    uptFilter,
    kategoriFilter,
    statusFilter,
    jenisFilter,
  }
}
